import { Component, OnInit, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { LookupService, LookupItem } from 'src/app/shared/services/lookup.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { forkJoin } from 'rxjs';
import { PgTitleComponent } from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';

@Component({
  selector: 'app-kantar-map',
  templateUrl: './kantar-map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    AgGridModule,
    MaterialOrganisationSelectorComponent,
    MaterialPgButtonComponent]
})
export class KantarMapComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();
  organisations: Organisation[] = [];
  notMapped: any[] = [];
  mappedOrganisations!: LookupItem;
  organisation?: Organisation ;
  showDropDown: boolean = false;
  index?: number;
  gridOptions: GridOptions = {};
  kantarOrganisation!: string;

  columnDefs = [
    { headerName: 'نام شرکت در کانتار', field:'name'},
    {
      headerName: 'Edit', cellRenderer: (params: any) =>
      {
        const button = this._renderer.createElement('button');
        this._renderer.addClass(button, 'btn');
        this._renderer.addClass(button, 'btn-link');
        this._renderer.addClass(button, 'btn-sm');
        this._renderer.setAttribute(button, 'title', 'Edit');
        const icon = this._renderer.createElement('i');
        this._renderer.addClass(icon, 'fa-solid');
        this._renderer.addClass(icon, 'fa-pen-to-square');
        this._renderer.appendChild(button, icon);
        this._renderer.listen(button, 'click', () => this.editRecord(params.data));
        return button;
      }
    },
  ];

  constructor(private _lookupService: LookupService,
    private _organisationService: OrganisationService,
    private _renderer: Renderer2,
    private _router: Router) { }

  ngOnInit() {
    this.title.emit('Kantar Organisations Map');
    this.gridOptions = AgGridService.getOptions();
    this.fillTables();
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  fillTables() {
    forkJoin([
      this._lookupService.getKantarNotMappedOrganisations(),
      this._organisationService.get(),
      this._lookupService.get('mapped_kantar_organisations')
    ]).subscribe(data => {
      this.notMapped = data[0].map(mapped => ({name:mapped}));
      this.organisations = data[1];
      this.mappedOrganisations = data[2];
    });
  }

  editRecord(data: any) {
    this.kantarOrganisation = data.name;
    this.showDropDown = true;
  }

  saveMapped(kantarOrganisation: string) {
    if (!this.mappedOrganisations) {
      this.mappedOrganisations = {
        categoryName: 'mapped_kantar_organisations',
        items: [[kantarOrganisation, this.organisation!.name]]
      };
      this._lookupService.add(this.mappedOrganisations).subscribe(() => {
        this.showDropDown = false;
      });
    } else {
      this.mappedOrganisations.items.push([kantarOrganisation, this.organisation!.name]);
      this._lookupService.update(this.mappedOrganisations).subscribe(() => {
        this.showDropDown = false;
      });
    }
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router
        .navigate(['/lpg-dist/organisations'])
        .then((e) => console.log(`Result of Navigation is ${e}`));
    });
  }

}
